import { useEffect, useState } from "react";
import api from "../../../services/api";

export function useHomeSummary() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    date: new Date().toISOString().split("T")[0],
    progress: { scheduledCount: 0, completedCount: 0, percent: 0 },
    todayItems: [],
    cards: [],
    notifications: { unreadCount: 0 },
  });
  const [summaryDrawerOpen, setSummaryDrawerOpen] = useState(false);
  const [notificationsDrawerOpen, setNotificationsDrawerOpen] = useState(false);

  const fetchSummary = async () => {
    try {
      const res = await api.get("/home/today");
      if (res?.data) {
        setData(res.data);
      }
    } catch {
      // Fallback amigável se a API ainda não tiver resposta
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  const handleQuickAction = async (actionObj, card) => {
    if (actionObj?.action === "addWater" || actionObj?.type === "add_water") {
      try {
        await api.post("/water", { amountMl: 250 });
        await fetchSummary();
      } catch {
        // sem ação
      }
    }
  };

  return {
    loading,
    data,
    fetchSummary,
    handleQuickAction,
    summaryDrawerOpen,
    setSummaryDrawerOpen,
    notificationsDrawerOpen,
    setNotificationsDrawerOpen,
  };
}
